import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=a0f6bfce&scoped=true&"
import script from "./Whiteboard.vue?vue&type=script&lang=js&"
export * from "./Whiteboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f6bfce",
  null
  
)

export default component.exports